/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Addons_Toast_Copilot_EnabledInputs */



/**
* | output |
* | --- |
* | "Compliance Copilot enabled." |
*
* @param {Sub_Addons_Toast_Copilot_EnabledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_toast_copilot_enabled = /** @type {((inputs?: Sub_Addons_Toast_Copilot_EnabledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Toast_Copilot_EnabledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Compliance Copilot aktiviert.")
	return /** @type {LocalizedString} */ ("Compliance Copilot enabled.")
});